module.exports = __webpack_public_path__ + "static/img/ac-hz.207ba0dc.jpg";